import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { set } from 'lodash';
import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import { ResultSource } from "../../../constants/ResultSource";
import { getDataSources } from '../../../services/dataSourceService';
import { getIdentifier, getSPV, updateIdentifier } from '../../../services/formService';
import { stripPTag } from '../../common/commonFuncs';
import Editor from '../../common/Quill';
import { logActivity } from '../../../services/utilService';

function WIdentifier(props) {
	const [isLoading, setLoadingState] = useState(true);
	const [identifierId, setidentifierId] = useState(0);

	const [identifierName, setidentifierName] = useState('');
	const [identifierDescription, setidentifierDescription] = useState('');
	const [identifierFormat, setIdentifierFormat] = useState('');
	const [isSystemGenerated, setSystemGenerated] = useState(false);
	const [dataSourceID, setDataSourceID] = useState(0);
	const [dataSourcesList, setDataSourcesList] = useState([]);
	const [storedProceduresList,setStoredProceduresList] = useState([]);
	const [storedProcedureSelected,setStoredProcedureSelected] = useState('');
	const [ openOptions,setOpenOptions] = useState('');
	useEffect(() => {
		const loadInitialState = async () => {
			// For rich text editor's link config
			const input = document.querySelector('input[data-link]');
			if (input) {
				input.dataset.link = '';
				input.placeholder = '';
			}

			const { data } = await getIdentifier(props.Widget.Widget_ID);

			if (data.length > 0) {
				setidentifierId(data[0].Identifier_ID);

				setidentifierName(data[0].Identifier_Name);
				setidentifierDescription(data[0].Identifier_Description);
				setIdentifierFormat(data[0].Identifier_Format);
				setDataSourceID(data[0].DataSource_ID);
				setStoredProcedureSelected(data[0].ResultSource_Content);
				setSystemGenerated(data[0].System_Generated);
			}
			const { data: dataSourcesList } = await getDataSources();
			setDataSourcesList(dataSourcesList);
			setLoadingState(false);
		};

		loadInitialState();
	}, []);

	const getConn = (dataSourceID) => {
		const source = dataSourcesList.find((source) => {
			return source.DataSource_ID === parseInt(dataSourceID);
		});
		return source.Connection_String;
	};

	const getOptions = async (dataSourceID) => {
		
		const { data } = await getSPV(ResultSource.SP , getConn(dataSourceID));
		setStoredProceduresList(data);
	  };
	const handleDataSourceChange = (event) => {
		const { value } = event.target;
		setDataSourceID(value)
		getOptions(value);
		
	};
	const handleRemove = () => {
		props.onRemove(props.Widget.Widget_ID);
	};

	const handleSave = async () => {
		const identifierNameFormatted = stripPTag(identifierName);

		const { data } = await updateIdentifier({
			Widget_ID: props.Widget.Widget_ID,
			Identifier_ID: identifierId,
			Identifier_Text: identifierNameFormatted,
			Description: identifierDescription,
			System_Generated: isSystemGenerated,
			Identifier_Format: identifierFormat,
			DataSource_ID:dataSourceID,
			ResultSource_Content: isSystemGenerated ? storedProcedureSelected : '',
		});

		if (data.includes('Error')) {
			toaster('error', data);
			logActivity('/formBuilder','WIDGET_QUES_SAVE_FAILED');
			return 0;
		} else {
			const Question_ID = data.split(':').pop();
			setidentifierId(identifierId);
			toaster('success', 'Question saved.');
			logActivity('/formBuilder','WIDGET_QUES_SAVE_SUCCESS');
			return Question_ID;
		}
	};

	const handleSPVChange = (event,value)=>{
		setStoredProcedureSelected(value);
	}
	const handleSystemGenerated = () => {
		setIdentifierFormat('');
		setSystemGenerated(!isSystemGenerated);
		setStoredProcedureSelected('');
		setDataSourceID('');
	};
	if (isLoading) return <div className='center'>Loading...</div>;
	return (
		<React.Fragment>
			<div className='form-group'>
				<label htmlFor='Identifier_Name'>Identifier Name</label>
				<Editor value={identifierName} onChange={(value) => setidentifierName(value)} />
			</div>
			<div className='form-group'>
				<TextField
					id={identifierId + 'Description'}
					label='Identifier Description'
					multiline
					fullWidth
					maxRows={4}
					value={identifierDescription}
					name='Description'
					variant='outlined'
					onChange={(e) => setidentifierDescription(e.target.value)}
				/>
			</div>
			<div className='form-group'>
				{!isSystemGenerated &&
					<TextField
						id={identifierId + 'Identifier Format'}
						label='Identifier Format'
						inputProps={{ maxLength: 10 }}
						fullWidth
						value={identifierFormat}
						name='Identifier'
						variant='outlined'
						onChange={(e) => setIdentifierFormat(e.target.value)}
					/>
				}
			</div>
			<div className='custom-control custom-switch mt-n2'>
				<input
					className='custom-control-input'
					id={'identifierSystemGenerated' + props.Widget.Widget_ID}
					type='checkbox'
					name='systemGenerated'
					checked={isSystemGenerated}
					value={isSystemGenerated}
					onChange={handleSystemGenerated}
				/>
				<label className='custom-control-label' htmlFor={'identifierSystemGenerated' + props.Widget.Widget_ID}>
					Generate ID automatically?
				</label>
			</div>
			{
				isSystemGenerated &&
				<>
				<div>
				<div className='form-group'>
					<label htmlFor={'DataSource' + props.Widget.Widget_ID}>Data Source</label>
					<select id={'DataSource' + props.Widget.Widget_ID} className='form-control' value={dataSourceID} name='dataSourceID' onChange={(event) => handleDataSourceChange(event)}>
						<option value='0'>Select</option>
						{dataSourcesList.map((source) => {
							return (
								<option key={source.DataSource_ID} value={source.DataSource_ID}>
									{source.Description}
								</option>
							);
						})}
					</select>
				</div>
				<div className='form-group'>
					<Autocomplete
						id={props.Widget.Widget_ID + 'resultSourceContent'}
						options={storedProceduresList}
						getOptionLabel={(option) => option}
						fullWidth
						size='small'
						value={storedProcedureSelected}
						name='storedProcedureSelected'
						onChange={handleSPVChange}
						inputValue={openOptions}
						onInputChange={(e, val) => {
							setOpenOptions( val );
						}}
						renderInput={(params) => <TextField {...params} label={'Stored Procedure Name'} />}
					/>
				</div>
			</div>
				</>
			}
			

			<div className='float-right'>
				<button className='btn btn-outline-primary m-2' onClick={handleSave}>
					Save
				</button>
				<button className='btn btn-outline-danger' onClick={handleRemove}>
					Delete
				</button>
			</div>
		</React.Fragment>
	);
}

export default WIdentifier;
